import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { supabase } from "../integrations/supabase/client.ts";

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {

    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const checkAuth = async() => {
            try {
                const { data } = await supabase.auth.getSession();
                setIsAuthenticated(!!data);
                setIsLoading(false);
            } catch (error) {
                console.error("Error checking authentication:", error);
                setIsAuthenticated(false);
                setIsLoading(false);
            }
        };
        checkAuth();
        const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
            setIsAuthenticated(!!session);
            setIsLoading(false);
        });    
        return () => subscription.unsubscribe();
    }, []);

    if (isLoading) {
        return <div className="flex items-center justify-center min-h-screen">Loading...</div>; 
    }
    if (!isAuthenticated){
        return <Navigate to="/" state={{ from: location }} replace />;
    }
    return <> {children} </>;
}

export default ProtectedRoute;
